import BraintreeClient from 'braintree-web/client';
import { AffirmCheckoutResponse } from '../../hooks/useCheckout/useAffirmCheckout';

const CARD_EXPIRY_REGEXP = /^([0-9]{2})([0-9]{2})$/;

export const tokenizeAffirmCard = async (data: AffirmCheckoutResponse, token: string) => {
  const client = await BraintreeClient.create({ authorization: token });

  const match = data.expiration.match(CARD_EXPIRY_REGEXP);

  const creditCard = {
    cardholderName: data.cardholder_name,
    number: data.number,
    expirationMonth: match?.[1],
    expirationYear: match?.[2],
    cvv: data.cvv,
    billingAddress: {
      countryCode: 'US',
      locality: data.billing_address.city,
      region: data.billing_address.state,
      postalCode: data.billing_address.zipcode,
      addressLine1: data.billing_address.line1,
      addressLine2: data.billing_address.line2
    }
  };

  const response = await new Promise<{ creditCards: { nonce: string }[] }>((resolve, reject) =>
    client.request(
      {
        endpoint: 'payment_methods/credit_cards',
        method: 'post',
        data: { creditCard }
      },
      (err, response) => (err ? reject(err) : resolve(response))
    )
  );

  return response.creditCards[0].nonce;
};
